import _ from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { Grid, TextField, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
  PortletFooter
} from 'components';

import styles from './styles';

class EditHeadword extends Component {


  state = {
    headword: this.props.headword,
    volunteer: true,
    url: '',
    error: null,
    partOfSpeech: 'Volunteer'
  };

  componentWillMount() {
    if(this.props.create){
      this.setState({volunteer: true})
    } else if(this.props.headword.attributes.partOfSpeech=="Volunteer"){
      this.setState({volunteer: true})
    } else {
      this.setState({volunteer: false})
    }
    if(this.props.headword.attributes.headword!=undefined){
      this.state.headword.attributes.headword = this.props.headword.attributes.headword
    } else {
      this.state.headword.attributes.headword = '';
    }
    if(!this.props.create){
      this.state.url='/vheadwords/' + this.props.headword.id;
    } else {
      this.state.url='/vheadwords/';
    }
  }

  componentWillUnmount() {
  }

  onChange(path, value) {
    let headword = this.state.headword;
    _.set(headword, path, value);
    this.setState({ headword });
  }

  renderHeadwordForm() {
    const { classes } = this.props;
    const { headword, volunteer } = this.state;

    return (
      <div>
      <Link to={this.state.url}> 
      <Button
              color="primary"
              variant="contained"
              className={classes.saveButton}
      >Back</Button>
      </Link> 
      <div><br></br></div>
      <Portlet>
        <PortletHeader>
          <PortletLabel title="Details" />
        </PortletHeader>
        <PortletContent noPadding>
          <form autoComplete="off" noValidate>
            <div className={classes.field}>
            {(volunteer) && (
              <div className={classes.row} style={{display:"flex"}} >
              <TextField
                className={classes.textField}
                label="Keyword"
                margin="dense"
                required
                value={headword.attributes.headword || ''}
                variant="outlined"
                onChange={(event) => this.onChange('attributes.headword', event.target.value || null)}
              />
              <div style={{width: '10%', marginRight:"5px", marginTop:"12px"}} >
              <Button onClick={event => this.onChange('attributes.headword', (headword.attributes.headword + 'ȝ'))} fullWidth='true' color="primary" size="small" variant="outlined">Add ȝ </Button>
             </div>
             </div>
             )} 
              {(!volunteer) && (
              <div className={classes.row} style={{display:"flex"}} >
              <TextField
                className={classes.textField}
                label="Keyword"
                margin="dense"
                required
                value={headword.attributes.headword || ''}
                variant="outlined"
              />
             </div>
             )} 
              <TextField
                className={classes.textField}
                label="Part of Speech"
                margin="dense"
                required
                value={headword.attributes.partOfSpeech || this.state.partOfSpeech }
                variant="outlined">
              </TextField>
            </div>
          </form>
        </PortletContent>
      </Portlet>
      </div>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={4}>
          <Grid item lg={7} md={7} xl={7} xs={12}>
            {this.renderHeadwordForm()}
          </Grid>
        </Grid>
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            className={classes.saveButton}
            onClick={this.props.onSave}
          >Save</Button>
        </div>
      </div>
    );
  }
}

EditHeadword.propTypes = {
  headword: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default compose(
  withRouter,
  withStyles(styles)
)(EditHeadword);
